// Animacje strony (GSAP + ScrollTrigger + SplitText, Lenis, canvas-confetti).
// Przy „ogranicz ruch” w systemie nic się nie rusza, a bez JavaScriptu strona wygląda jak zwykle.
import {ScrollTrigger} from "./shared";
import {initSmoothScroll} from "./smooth-scroll";
import {initHeroes} from "./hero";
import {initReveals, revealAll} from "./reveal";
import {initTimelines} from "./timeline";
import {initMarquees} from "./marquee";
import {initFaq} from "./faq";
import {initInteractions} from "./interactions";
import {initProgress, initBackToTop} from "./ui-extras";
import {pawBurst, pawBurstFrom} from "./confetti";

/**
 * Uruchamia jeden krok tak, żeby jego awaria nie zabrała ze sobą reszty.
 * Wcześniej wystarczył jeden wyjątek, żeby start animacji przerwał się w połowie,
 * a treść ukryta przez GSAP została niewidoczna na dobre.
 */
function safely(name, run) {
    try {
        run();
        return true;
    } catch (error) {
        console.error("Animacje – " + name + ":", error);
        return false;
    }
}

export function initMotion() {
    const root = document.documentElement;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        root.classList.remove("cc-anim");
        return;
    }
    // cc-anim dodaje skrypt w <head>; jeśli zdążył ją zdjąć bezpiecznik (wolne łącze), treść już widać – bez animacji wejścia.
    const intro = root.classList.contains("cc-anim");
    const fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    const lenis = initSmoothScroll();
    safely("pasek postępu", initProgress);
    safely("powrót na górę", () => initBackToTop(lenis));
    safely("wstęgi", initMarquees);
    safely("osie czasu", initTimelines);
    safely("pytania", initFaq);
    if (intro && !safely("wejścia", initReveals)) {
        // Wejścia ukrywają treść zanim ją pokażą – jeśli padły w połowie, odsłaniamy wszystko ręcznie.
        safely("odsłonięcie awaryjne", revealAll);
    }
    if (fine) {
        safely("interakcje", initInteractions);
    }
    initHeroes({intro, fine}).catch((error) => console.error("Animacje – hero:", error)).finally(() => {
        root.classList.add("cc-anim-ready");
        ScrollTrigger.refresh();
    });

    // Konfetti z łapek: wysłany formularz i wybór pakietu.
    document.addEventListener("cc:celebrate", (event) => {
        if (event.detail?.el) {
            pawBurstFrom(event.detail.el, {count: 110, spread: 100});
        }
    });
    document.addEventListener("click", (event) => {
        const plan = event.target.closest("[data-cc-plan]");
        if (plan) {
            pawBurst(event.clientX, event.clientY, {count: plan.closest(".cc-plan--featured") ? 80 : 40});
        }
    });

    document.fonts?.ready.then(() => ScrollTrigger.refresh());
    // np. po wczytaniu ramek z Instagrama zmienia się wysokość strony
    document.addEventListener("cc:layout", () => ScrollTrigger.refresh());
}
